import { Link } from "@digdir/designsystemet-react";
import type { ReactNode } from "react";
import { parseLastChangedValue } from "../filter";

const missingLinkValues = new Set(["", "-", "link", "ia"]);
const sharepointHost = "https://enova365.sharepoint.com";

function isLinkFieldLabel(label?: string): boolean {
    return (label ?? "").toLocaleLowerCase("nb").includes("lenke");
}

function getLinkHref(value: string): string | null {
    if (/^https?:\/\//i.test(value)) {
        return value;
    }

    if (/^www\./i.test(value)) {
        return `https://${value}`;
    }

    if (/^(\.\.\/)+:[a-z]:\//i.test(value) || /^\/?:[a-z]:\//i.test(value)) {
        const withoutTraversal = value.replace(/^(\.\.\/)+/, "");
        const normalizedPath = withoutTraversal.startsWith("/") ? withoutTraversal : `/${withoutTraversal}`;
        return `${sharepointHost}${normalizedPath}`;
    }

    return null;
}

export function renderDetailValue(value: string, label?: string): ReactNode {
    const trimmedValue = value.trim();
    const normalizedValue = trimmedValue.toLocaleLowerCase("nb");
    const isLinkLabel = isLinkFieldLabel(label);

    if (isLinkLabel && missingLinkValues.has(normalizedValue)) {
        return <span className="rapportkatalog-link-missing-indicator">Mangler lenke</span>;
    }

    const href = getLinkHref(trimmedValue);
    if (href) {
        return (
            <Link href={href} target="_blank" rel="noreferrer">
                {trimmedValue}
            </Link>
        );
    }

    if (isLinkLabel) {
        return <span className="rapportkatalog-link-unknown-indicator">Ukjent lenkeformat: {trimmedValue}</span>;
    }

    return value;
}

export function renderLastChangedValue(value?: string): ReactNode {
    const normalizedValue = value?.trim() ?? "";

    if (normalizedValue.length === 0) {
        return <span className="rapportkatalog-last-changed-indicator">Mangler dato</span>;
    }

    if (parseLastChangedValue(normalizedValue) === Number.NEGATIVE_INFINITY) {
        return <span className="rapportkatalog-last-changed-indicator">Ugyldig dato</span>;
    }

    return renderDetailValue(normalizedValue);
}
